export enum ExteriorNonSupply {
    MATERIAL_ID = 918,
    EDGE_ID = 1452,
    DOOR_ID = 33,
    EXTERIOR = 0,
}
